import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { loginUser, selectIsAuthenticated, selectUser } from '../redux/slices/authSlice';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);

  useEffect(() => {
    if (isAuthenticated && user) {
      navigate('/admin', { replace: true });
    }
  }, [isAuthenticated, user, navigate]);

  const handleGoogleSuccess = (credentialResponse) => {
    if (!credentialResponse?.credential) return;
    dispatch(loginUser({ credential: credentialResponse.credential }));
  };

  const handleGoogleFailure = () => {
    alert("Google Login Failed");
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-teal-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
      </div>

      {/* Go Home Button - Top Right */}
      <button
        onClick={handleGoHome}
        className="absolute top-6 right-6 flex items-center gap-2 px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 hover:text-teal-600 rounded-lg shadow-md transition-all duration-200 border border-gray-200"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
        <span className="font-medium">Home</span>
      </button>

      {/* Login card */}
      <div className="relative bg-white p-12 rounded-3xl shadow-2xl flex flex-col items-center max-w-md w-full mx-4 border border-gray-100">
        {/* Logo or Icon */}
        <div className="mb-6 bg-gradient-to-br from-teal-500 to-blue-600 p-4 rounded-2xl">
          <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>

        {/* Title */}
        <h2 className="text-3xl font-bold mb-2 text-gray-800 text-center">Admin Portal</h2>
        <p className="text-gray-500 mb-8 text-center">Secure authentication required</p>

        {/* Google Login Button */}
        <div className="w-full flex justify-center">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleFailure}
            shape="pill"
            width="340"
          />
        </div>

        {/* Footer note */}
        <p className="mt-6 text-xs text-gray-400 text-center">
          Only authorized administrators can access this area
        </p>
      </div>

      {/* Bottom branding */}
      <div className="mt-8 text-center">
        <p className="text-sm text-gray-500">
          Powered by <span className="font-semibold text-teal-600">ThinkRealty</span>
        </p>
      </div>
    </div>
  );
};

export default Login;
